<div fxLayout="row">
    <div fxLayout="column" fxFlex="1 1 100%">
        <div fxLayout="row wrap" fxFlex="0 1 100%" fxLayoutGap="5px" style="align-items:center"
            class="dashboard-button-bar">
            <button mat-mini-fab color="primary" class="menu-button" (click)="nodeSideBarOpened = !nodeSideBarOpened">
                <mat-icon>menu_open</mat-icon>
            </button>
            <p-calendar [(ngModel)]="operatingDate" [showIcon]="true" [maxDate]="maxOperatingDate"
                (onSelect)="onOperatingDateSelected($event)"></p-calendar>
            <ng-container *ngIf="viewMode === 'DESIGN'">
                <button *ngIf="itemType === 'DASHBOARD_CONFIG'" [disabled]="loading || treeLoading" pButton pRipple
                    type="button" class="p-button-raised dashboard-button" pButton pRipple label="New Dashboard"
                    icon="pi pi-plus" (click)="newReportDashboard()">
                </button>
                <button *ngIf="itemType === 'METRIC_DEFINITION'" [disabled]="loading || treeLoading" pButton pRipple
                    type="button" class="p-button-raised dashboard-button" pButton pRipple label="New Metric"
                    icon="pi pi-plus" (click)="newReportDashboardMetricDefinition()">
                </button>
                <button *ngIf="itemType === 'STOCK_RATIO_DEFINITION'" [disabled]="loading || treeLoading" pButton
                    pRipple type="button" class="p-button-raised dashboard-button" pButton pRipple
                    label="New Stock Ratio" icon="pi pi-plus" (click)="newReportDashboardStockRatioDefinition()">
                </button>
                <button *ngIf="itemType === 'DASHBOARD_CONFIG'"
                    [disabled]="!selectedNode || selectedNode.contentType !== 'DASHBOARD' " pButton pRipple
                    type="button" class="p-button-raised dashboard-button" pButton pRipple label="Add Component"
                    icon="pi pi-plus-circle" (click)="newReportDashboardComponent()">
                </button>
                <mat-divider [vertical]="true"></mat-divider>
                <!-- <button [disabled]="!selectedNode" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="Edit" icon="pi pi-pencil"
                    (click)="editSelected()">
                </button>
                <button [disabled]="!selectedNode" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="Copy" icon="pi pi-copy"
                    (click)="copySelected()">
                </button>
                <button [disabled]="!selectedNode" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="Paste" icon="pi pi-file"
                    (click)="paste()">
                </button> -->
                <p-splitButton class="p-button-raised dashboard-split-button" [disabled]="!selectedNode"
                    [model]="editSplitItems" label="Edit" icon="pi pi-pencil" (onClick)="editSelected()">

                </p-splitButton>
                <mat-divider [vertical]="true"></mat-divider>
                <p-splitButton [disabled]="!selectedNode" *ngIf="itemType === 'DASHBOARD_CONFIG'"
                    class="p-button-raised dashboard-split-button"
                    [label]="(selectedNode && selectedNode.contentType === 'DASHBOARD') ? 'Preview Dashboard' : (selectedNode && selectedNode.contentType === 'COMPONENT') ? 'Preview Component' : 'Preview'"
                    icon="pi pi-eye" (onClick)="previewReportDashboard(selectedNode, false)"
                    [model]="previewSplitItems">
                </p-splitButton>
                <p-overlayPanel #previewPublishPanel [showCloseIcon]="true" [style]="{width: '30vw'}"
                    [baseZIndex]="-500">
                    <div *ngIf="latestPreviewResult" fxFlex="1 1 100%">
                        <app-report-dashboard-publish [isPreviewMode]="true"
                            [previewIdentifier]="latestPreviewResult.request.reportDashboardConfig.identifier"
                            [reportDashboardIdentifier] [designers]="dashboardConfigsResult.users?.designers"
                            [batchIdentifier]="batchIdentifier" [allowRunTypes]="true" [allowRecipientTypes]="true">
                        </app-report-dashboard-publish>
                    </div>
                </p-overlayPanel>
                <mat-divider [vertical]="true"></mat-divider>
                <button [disabled]="!selectedNode || treeLoading" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="Save" icon="pi pi-save"
                    (click)="saveSelectedReportDashboard()">
                </button>
                <button [disabled]="treeLoading" pButton pRipple type="button" class="p-button-raised dashboard-button"
                    pButton pRipple label="Reload" icon="pi pi-refresh" (click)="reloadReportDashboards()">
                </button>
                <mat-divider [vertical]="true"></mat-divider>
                <button [disabled]="loading || treeLoading" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="Helper" icon="pi pi-external-link"
                    (click)="openSyntheticColumnBuilder($event)" matTooltip="Synthetic Column Helper"
                    matTooltipPosition="right">
                </button>
                <div fxFlex="1 1 auto"></div>
                <button [disabled]="!selectedNode || treeLoading" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="Delete" icon="pi pi-trash"
                    (click)="deleteSelected()">
                </button>
            </ng-container>
            <ng-container *ngIf="viewMode === 'VIEW'">
                <button [disabled]="!selectedNode" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="View" icon="pi pi-eye"
                    (click)="viewSavedReportDashboard()">
                </button>
                <!-- <div fxFlex="1 1 auto"></div> -->

                <button *ngIf="selectedNode" type="button" class="p-button-raised dashboard-button" pButton pRipple
                    [disabled]="selectedNode.contentType === 'INVESTIGATION'"
                    [label]="selectedNode.isMarked ? 'De-Queue for Publish': 'Queue for Publish'"
                    [icon]="selectedNode.isMarked ? 'pi pi-minus' : 'pi pi-plus'"
                    (click)="selectedNode.isMarked = !selectedNode.isMarked">
                </button>
                <button type="button" class="p-button-raised dashboard-button" pButton pRipple icon="pi pi-envelope"
                    (click)="viewPublishPanel.toggle($event)">
                </button>
                <p-overlayPanel #viewPublishPanel [showCloseIcon]="true" [style]="{width: '30vw'}">
                    <div *ngIf="dashboardConfigsResult && viewReportDashboardNodes" fxFlex="1 1 100%">
                        <app-report-dashboard-publish [reportDashboardNodes]="viewReportDashboardNodes"
                            [designers]="dashboardConfigsResult.users?.designers" [batchIdentifier]="batchIdentifier">
                        </app-report-dashboard-publish>
                    </div>
                </p-overlayPanel>
            </ng-container>
            <ng-container *ngIf="viewMode === 'HISTORY'">
                <button [disabled]="!selectedNode ||  !selectedNode.previewResult" pButton pRipple type="button"
                    class="p-button-raised dashboard-button" pButton pRipple label="View" icon="pi pi-eye"
                    (click)="previewReportDashboard(selectedNode, false, selectedNode?.previewResult)">
                </button>
            </ng-container>
        </div>
        <div fxLayout="column" fxFlex="1 1 100%" [fxHide]="viewMode === 'PUBLISH'">
            <p-contextMenu #contextMenu [model]="contextMenuItems"></p-contextMenu>
            <mat-drawer-container fxFlex="1 1 80vh">
                <mat-drawer mode="side" [(opened)]="nodeSideBarOpened" disableClose>
                    <div fxLayout="column" fxFlex="1 1 100%" [fxHide]="viewMode !== 'DESIGN' && viewMode !== 'VIEW'">
                        <div fxLayout="row" *ngIf="viewMode === 'DESIGN' && license?.dashboard?.metricDefinitions">
                            <div class="p-fluid" fxFlex="1 1 auto">
                                <p-selectButton [options]="itemTypeOptions" (onChange)="onItemTypeChange($event)"
                                    [(ngModel)]="itemType" optionLabel="label" optionValue="value"></p-selectButton>
                            </div>
                        </div>
                        <div fxLayout="row">
                            <button pButton pRipple type="button" fxFlex="1 1 15%"
                                [disabled]="filterOwner || filterCollaborator || filterViewer"
                                class="p-button-outlined dashboard-button" styleClass="p-button-sm" pButton pRipple
                                (click)="moveNode('TOP')" icon="pi pi-angle-double-up"></button>
                            <button pButton pRipple type="button" fxFlex="1 1 15%"
                                [disabled]="filterOwner || filterCollaborator || filterViewer"
                                class="p-button-outlined dashboard-button" styleClass="p-button-sm" pButton pRipple
                                (click)="moveNode('UP')" icon="pi pi-angle-up">
                            </button>
                            <button pButton pRipple type="button" fxFlex="1 1 15%"
                                [disabled]="filterOwner || filterCollaborator || filterViewer"
                                class="p-button-outlined dashboard-button" styleClass="p-button-sm" pButton pRipple
                                (click)="moveNode('DOWN')" icon="pi pi-angle-down"></button>
                            <button pButton pRipple type="button" fxFlex="1 1 15%"
                                [disabled]="filterOwner || filterCollaborator || filterViewer"
                                class="p-button-outlined dashboard-button" styleClass="p-button-sm" pButton pRipple
                                (click)="moveNode('BOTTOM')" icon="pi pi-angle-double-down"></button>
                            <div fxFlex="1 1 auto"></div>
                        </div>
                        <div fxLayout="row" class="p-fluid">
                            <p-toggleButton fxFlex="1 1 auto" [(ngModel)]="filterOwner"
                                (onChange)="filterDesignAndViewNodes()" onLabel="Owner" offLabel="Owner"
                                [onIcon]="'pi pi-user'" offIcon="pi pi-circle-off">
                            </p-toggleButton>
                            <p-toggleButton fxFlex="1 1 auto" [(ngModel)]="filterCollaborator"
                                (onChange)="filterDesignAndViewNodes()" onLabel="Collaborator" offLabel="Collaborator"
                                [onIcon]="'pi pi-user'" offIcon="pi pi-circle-off"></p-toggleButton>
                            <p-toggleButton fxFlex="1 1 auto" [(ngModel)]="filterViewer"
                                (onChange)="filterDesignAndViewNodes()" onLabel="Viewer" offLabel="Viewer"
                                [onIcon]="'pi pi-user'" offIcon="pi pi-circle-off"></p-toggleButton>

                        </div>
                        <span class="p-input-icon-right" fxFlex="0 0 auto" fxLayout="row">
                            <i class="pi pi-search"></i>
                            <input type="text" pInputText (input)="onFilterChange($event.target.value)"
                                class="filter-input" />
                        </span>
                        <p-scrollPanel [style]="{width: '100%', height: '75vh'}" fxLayout="column"
                            class="report-dashboard-tree-panel">
                            <div *ngIf="viewMode === 'DESIGN'" fxFlex="1 1 100%" fxLayout="column">
                                <p-tree fxFlex="1 1 auto" [value]="filteredDesignReportDashboardNodes"
                                    selectionMode="single" [(selection)]="selectedNode"
                                    (onNodeSelect)="onReportDashboardSelected($event)" [contextMenu]="contextMenu"
                                    [draggableNodes]="true" [droppableNodes]="true" draggableScope="self"
                                    droppableScope="self" [validateDrop]="true"
                                    (onNodeDrop)="onReportDashboardNodeDrop($event)"
                                    [styleClass]="'dashboard-component-tree'" [loading]="treeLoading" [filter]="false">
                                </p-tree>
                                <div fxLayout="1 1 auto"></div>
                            </div>
                            <ng-container *ngIf="viewMode === 'VIEW'" #viewDiv>
                                <p-tree fxFlex="1 1 auto" [value]="filteredViewReportDashboardNodes"
                                    selectionMode="single" [(selection)]="selectedNode"
                                    (onNodeSelect)="onReportDashboardSelected($event)" [draggableNodes]="true"
                                    [droppableNodes]="true" draggableScope="self" droppableScope="self"
                                    [validateDrop]="true" (onNodeDrop)="onReportDashboardNodeDrop($event)"
                                    [styleClass]="'dashboard-component-tree'" [loading]="treeLoading" [filter]="false">

                                    <ng-template let-node pTemplate="default">
                                        <div fxLayout="row">
                                            <div fxFlex="0 0 auto" fxLayout="column">
                                                <span>{{node.label}}</span>
                                                <i *ngIf="node.subLabel">{{node.subLabel}}</i>
                                            </div>
                                            <div fxFlex="1 1 auto"></div>
                                            <div fxFlex="1 1 auto">
                                                <i *ngIf="node.isMarked" class="marked-indicator pi pi-star"></i>
                                            </div>
                                        </div>
                                    </ng-template>
                                </p-tree>
                                <div fxLayout="1 1 auto"></div>
                            </ng-container>
                        </p-scrollPanel>
                    </div>
                    <div fxLayout="column" fxFlex="1 1 100%" [fxHide]="viewMode !== 'HISTORY'">
                        <p-tree fxFlex="1 1 auto" [value]="previewedReportDashboardNodes" selectionMode="single"
                            [(selection)]="selectedNode" (onNodeSelect)="onReportDashboardSelected($event)"
                            [styleClass]="'dashboard-component-tree'">
                            <ng-template let-node pTemplate="default">
                                <div fxLayout="row">
                                    <div fxFlex="0 0 auto" fxLayout="column">
                                        <span>{{node.label}}</span>
                                        <i>{{node.previewResult?.queryStatus}}</i>
                                        <i>{{node.requestAge}}</i>
                                    </div>
                                    <div fxFlex="1 1 auto"></div>
                                </div>
                            </ng-template>
                        </p-tree>
                    </div>
                </mat-drawer>
                <mat-drawer-content>
                    <p-progressSpinner *ngIf="previewLoading || loading" [style]="{width: '100px', height: '100px'}"
                        fxFlex="0 0 80%" class="spinner" animationDuration="2s"></p-progressSpinner>
                    <div fxFlex="1 1 100%" [fxHide]="viewMode === 'PUBLISH' || previewLoading">
                        <!-- <p-scrollPanel [style]="{width: '100%', height: '80vh'}"> -->
                        <!-- <img *ngIf="previewURL" class="preview-img" max-width="100%" max-height="100%" [src]="previewURL" /> -->
                        <!-- <div [fxHide]="!previewHTML" max-width="100%" max-height="100%" [innerHtml]="previewHTML"></div> -->
                        <app-report-dashboard-preview-inner [fxHide]="!previewHTML || previewLoading || loading"
                            max-width="100%" max-height="100%" [innerHTMLToUse]="previewHTML">
                        </app-report-dashboard-preview-inner>
                        <div [fxHide]="!inventoryUrl" max-width="100%" max-height="100%" class="inventory-container">
                            <div class="inventory-button">
                                <a [href]="inventoryUrl" class="download-link inventory-link"
                                    [download]="inventoryFileName">
                                    <mat-icon [inline]="true" class="download-icon">get_app</mat-icon>Inventory Results:
                                    {{inventoryFileName}}
                                </a>
                            </div>
                        </div>
                        <div [fxHide]="!downloadUrl" max-width="100%" max-height="100%">
                            <a [href]="downloadUrl" class="download-link" [download]="downloadFileName"
                                style="position: fixed;left: 45%;top: 50%;">
                                <mat-icon [inline]="true" class="download-icon">get_app</mat-icon>Download Results:
                                {{downloadFileName}}
                            </a>
                        </div>
                        <div fxLayout="column" *ngIf="investigationData">
                            <div fxLayout="row">
                                <p-table #dt class="liquitics-box" [columns]="investigationColumns"
                                    [value]="investigationData" [scrollable]="true" [rows]="30" scrollHeight="75vh"
                                    sortMode="multiple" [resizableColumns]="true" [loading]="loading"
                                    [exportFilename]="investigationFileName" styleClass="p-datatable-striped">
                                    <ng-template pTemplate="caption">
                                        <div style="text-align: right">
                                            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
                                            <input type="text" pInputText size="50" placeholder="Global Filter"
                                                (input)="dt.filterGlobal($event.target.value, 'contains')"
                                                style="width:auto">
                                        </div>
                                        <button type="button" fxFlex="0 0 auto" pButton pRipple icon="fa fa-file-o"
                                            iconPos="left" label="Export All Data" (click)="dt.exportCSV()"
                                            style="float:left"></button>
                                    </ng-template>
                                    <ng-template pTemplate="colgroup" let-columns>
                                        <colgroup>
                                            <col *ngFor="let col of columns" style="width:150px">
                                        </colgroup>
                                    </ng-template>
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                                                style="text-align:center; font-size: inherit">
                                                <p-sortIcon [field]="col.field"></p-sortIcon>
                                                {{col.header}}
                                                <p-columnFilter *ngIf="col.type === 'string'" type="text"
                                                    [field]="col.field" display="menu"></p-columnFilter>
                                                <p-columnFilter *ngIf="col.type === 'number'" type="numeric"
                                                    [field]="col.field" display="menu"></p-columnFilter>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                                        <tr [pSelectableRow]="rowData">
                                            <td *ngFor="let col of columns"
                                                style="text-align:center; font-size: inherit">
                                                <ng-container *ngIf="col.type === 'number'">
                                                    {{rowData[col.field] | number:'1.2-6'}}
                                                </ng-container>
                                                <ng-container *ngIf="col.type === 'string'">
                                                    {{rowData[col.field]}}
                                                </ng-container>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </div>
                        </div>
                        <!-- </p-scrollPanel> -->
                        <!-- <div fxFlex="1 1 auto" class="iframe-container" *ngIf="previewURL"> -->
                        <!-- <img *ngIf="previewBase64 != null" max-width="100%" max-height="100%" class="topbar-icon avatar" [src]="previewBase64"/> -->
                        <!-- <iframe [src]="previewURL" [style]="{width: '100vw'}"></iframe> -->
                        <!-- </div> -->
                    </div>
                </mat-drawer-content>
            </mat-drawer-container>
        </div>
    </div>
</div>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle" [style]="{width: '50vw'}"></p-confirmDialog>